<template>
  <div>
    <strong>Webhooks</strong>
    <br/><br/>
    <table>
      <thead>
        <tr>
          <td><strong>Store</strong></td>
          <td><strong>Installed</strong></td>
          <td><strong>Action</strong></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="store in stores">
          <td>{{ store.url }}</td>
          <td>
            <span v-if="store.all_installed">Yes</span>
            <span v-else-if="store.shopify_error">Error</span>
            <span v-else>No</span>
          </td>
          <td>
            <span v-if="store.all_installed"><a @click="uninstall(store.url)" class="button is-link is-danger" :disabled="disable_buttons"><span>Remove</span></a></span>
            <span v-else-if="store.shopify_error">Error</span>
            <span v-else><a @click="install(store.url)" class="button is-link is-success" :disabled="disable_buttons"><span>Install</span></a></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import auth from '../auth'
import axios from 'axios'

export default {
  name: 'Webhooks',
  data () {
    return {
      stores: [],
      disable_buttons: false
    }
  },
  methods: {
    fetch_status () {
      axios.get('/api/status').then(response => {
        this.stores = response.data.shops
      })
    },
    install (storeUrl) {
      this.disable_buttons = true
      axios.post(
        '/api/install',
        { shop_url: storeUrl }
      ).then(response => {
        this.stores = response.data.shops
        this.$root.open_message_modal('Webhooks installed!')
      }).finally(resp => {
        this.disable_buttons = false
      })
    },
    uninstall (storeUrl) {
      this.disable_buttons = true
      axios.post(
        '/api/uninstall',
        { shop_url: storeUrl }
      ).then(response => {
        this.stores = response.data.shops
        this.$root.open_message_modal('Webhooks uninstalled!')
        this.disable_buttons = false
      }).finally(resp => {
        this.disable_buttons = false
      })
    }
  },
  created () {
    auth.checkAuth(['config_webhooks'])
    this.fetch_status()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table {
  display: inline-block;
}

th, td {
  padding: 15px;
  border-bottom: 1px solid #ddd;
}
</style>
